import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

//  查询材料材质实例
export const queryUeItems: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUeItems', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/baseinfo/ueitem/materialinstance', payload);
    commit('setUeItems', { data: !!res ? [res] : [] });
  } catch (e) {
    commit('setUeItems', { data: [] });
  }
};

//  查询模型材质实例
export const queryUeItemMesh: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUeItems', { ...state.list, loading: true });
    const detail: { id: number } | null = await $http.post('/baseinfo/ueitem/mesh', payload);
    if (detail && detail.id) {
      const res = await $http.post('/baseinfo/ueitem/materialinstance/listwithparent', { id: detail.id });
      commit('setUeItems', { data: res });
    }
  } catch (e) {
    commit('setUeItems', { data: [] });
  }
};

// 下载配置
export const downloadConfig: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    // const res: { url: string; } = await $http.post('/file/get', payload);
    const res: { url: string; } = await $http.post('/v1/system/file/download', payload);
    window.location.href = res?.url || '';
  } catch (e) {
    throw Error(e);
  }
};
